import React  from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import { FaHome, FaUser, FaCamera, FaEnvelope, FaFilm } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Navbar.css";

const Navbar = () => {

  // Function to close the navbar on link click
  const closeNavbar = () => {
    const navbarToggler = document.querySelector(".navbar-toggler");
    const navbarCollapse = document.querySelector(".navbar-collapse");
    if (navbarCollapse.classList.contains("show")) {
      navbarToggler.click();
    }
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark fixed-top shadow" style={{ backgroundColor: "#0d0d0d" }}>
      <div className="container">
        <Link className="navbar-brand fw-bold text-danger" to="/">
          <img src={logo} alt="Navaneeth Photography" style={{ height: "200px", width: "auto" }} />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav gap-3">
            <li className="nav-item">
              <Link className="nav-link d-flex align-items-center gap-2" to="/" onClick={closeNavbar}>
                <FaHome /> Welcome Light
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link d-flex align-items-center gap-2" to="/about" onClick={closeNavbar}>
                <FaUser /> Behind the Frame
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link d-flex align-items-center gap-2" to="/shoot" onClick={closeNavbar}>
                <FaCamera /> Captured Moments
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link d-flex align-items-center gap-2" to="/trailers" onClick={closeNavbar}>
                <FaFilm /> Visual Tales
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link d-flex align-items-center gap-2" to="/contact" onClick={closeNavbar}>
                <FaEnvelope /> Reach Out
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
